import { useTranslation } from "react-i18next";
import { LayoutGrid, UserPlus, Banknote, CalendarDays, Clock, LogOut } from "lucide-react";
import { RAISED3D, PRESSED3D } from "./neu3d";

const TABS = [
  { k: "all", kinds: null, lbl: "tabAll", icon: LayoutGrid, grad: "from-slate-400 to-slate-600" },
  { k: "join", kinds: [], lbl: "tabJoin", icon: UserPlus, grad: "from-cyan-400 to-cyan-600" },
  { k: "advance", kinds: ["advance"], lbl: "tabAdvance", icon: Banknote, grad: "from-amber-400 to-amber-600" },
  { k: "leave", kinds: ["leave", "resume"], lbl: "tabLeave", icon: CalendarDays, grad: "from-emerald-400 to-emerald-600" },
  { k: "timeOff", kinds: ["timeOff"], lbl: "tabTimeOff", icon: Clock, grad: "from-violet-400 to-violet-700" },
  { k: "resignation", kinds: ["resignation"], lbl: "tabResignation", icon: LogOut, grad: "from-rose-400 to-rose-600" },
];

export const kindsForTab = (tab) => (TABS.find((x) => x.k === tab) || {}).kinds;

export const RequestTabs = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-3 gap-3 sm:grid-cols-6" data-testid="requests-tabs">
      {TABS.map(({ k, lbl, icon: Icon, grad }) => {
        const active = value === k;
        return (
          <button
            key={k}
            type="button"
            data-testid={`requests-tab-${k}`}
            aria-current={active}
            onClick={() => onChange(k)}
            style={{ boxShadow: active ? PRESSED3D : RAISED3D, transform: active ? "translateY(3px)" : undefined }}
            className={`flex min-h-[80px] flex-col items-center justify-center gap-2 rounded-3xl bg-gradient-to-b ${grad} px-2 py-3 text-center text-xs font-black text-white [text-shadow:0_1px_2px_rgba(0,0,0,.4)] transition-transform duration-150 ${active ? "ring-2 ring-white/70" : "hover:-translate-y-0.5"}`}
          >
            <Icon className="h-6 w-6" strokeWidth={2.6} />
            <span className="leading-tight">{t(`requests.${lbl}`)}</span>
          </button>
        );
      })}
    </div>
  );
};
